export default "__VITE_ASSET__DCyzslEM__"